import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const STORAGE_KEY = "ayushjha-theme";

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    try { return sessionStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light"; }
    catch { return "light"; }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try { sessionStorage.setItem(STORAGE_KEY, theme); } catch { /* Theme still works when storage is unavailable. */ }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <button
      type="button"
      onClick={toggle}
      className="theme-toggle"
      data-testid="theme-toggle"
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
    >
      <span className={`theme-toggle__icon ${theme === "dark" ? "is-active" : ""}`} aria-hidden>
        <Moon size={15} strokeWidth={1.6} />
      </span>
      <span className={`theme-toggle__icon ${theme === "light" ? "is-active" : ""}`} aria-hidden>
        <Sun size={15} strokeWidth={1.6} />
      </span>
      <span className={`theme-toggle__thumb theme-toggle__thumb--${theme}`} aria-hidden />
    </button>
  );
}
